exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lucky-wheel-datetime-hide-now .el-picker-panel__footer .el-button--text {\n  display: none;\n}\n", ""]);

// exports
